import { Tabs } from 'antd';
import React, { useMemo } from 'react';
import './TranslationModalTabs.css';
import { useSelector } from 'react-redux';
import TranslateTest from '../../pages/TranslateTest/TranslateTest';
import AddQuestions from '../AddQuestions/AddQuestions';
import CountryFlag from '../CountryFlag/CountryFlag';
import { t } from '../../i18n/i18n';

const { TabPane } = Tabs;

const TranslationModalTabs = ({ languageTestToShow, testgroupWithThemes, onSaveSuccess }) => {
  const { originalLanguage, originalIsoCode, isoCodeToTranslate, languageToTranslate } =
    useSelector((state) => state.testGroups);
  const defaultActiveKey = useMemo(
    () => (languageTestToShow === originalLanguage ? originalLanguage : languageToTranslate),
    [languageTestToShow, originalLanguage]
  );

  return (
    <Tabs
      defaultActiveKey={defaultActiveKey}
      destroyInactiveTabPane={false}
      className="centered-tabs"
      type="line"
    >
      <TabPane
        tab={
          <>
            <span className="mx-1 text-muted">{t('TEST_ORIGINAL_LANGUAGE')}</span>
            <CountryFlag countryIso={originalIsoCode} size="sm mx-3" />
          </>
        }
        key={originalLanguage}
      >
        <div className="p-2 overflow-y-auto mx-5">
          <AddQuestions testGroupABM testgroupWithThemes={testgroupWithThemes} readOnly />
        </div>
      </TabPane>

      <TabPane
        tab={
          <>
            <span className="mx-1 text-muted">{t('TEST_DESIRE_LANGUAGE')}</span>
            <CountryFlag countryIso={isoCodeToTranslate} size="sm mx-3" />
          </>
        }
        key={languageToTranslate}
      >
        <TranslateTest onSaveSuccess={onSaveSuccess} />
      </TabPane>
    </Tabs>
  );
};

export default TranslationModalTabs;
